import React from 'react';

const SvgExclamationCircle = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      width={props.width || 16}
      height={props.height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 7.75C16 12.0312 12.5299 15.5 8.25 15.5C3.97009 15.5 0.5 12.0312 0.5 7.75C0.5 3.47134 3.97009 0 8.25 0C12.5299 0 16 3.47134 16 7.75ZM8.25 9.3125C7.45609 9.3125 6.8125 9.95609 6.8125 10.75C6.8125 11.5439 7.45609 12.1875 8.25 12.1875C9.04391 12.1875 9.6875 11.5439 9.6875 10.75C9.6875 9.95609 9.04391 9.3125 8.25 9.3125ZM6.88522 4.14544L7.11703 8.39544C7.12787 8.59431 7.29231 8.75 7.49147 8.75H9.00853C9.20769 8.75 9.37213 8.59431 9.38297 8.39544L9.61478 4.14544C9.6265 3.93063 9.45547 3.75 9.24034 3.75H7.25962C7.0445 3.75 6.8735 3.93063 6.88522 4.14544Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgExclamationCircle;
